import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { StatsigClient } from "@statsig/js-client";
import { StatsigProvider } from "@statsig/react-bindings";
import { getOrCreateUserId } from "./utils/statsig";

const statsigClient = new StatsigClient(
  process.env.REACT_APP_STATSIG_CLIENT_KEY,
  { userID: getOrCreateUserId() },
);

const root = ReactDOM.createRoot(document.getElementById("root"));

function renderApp() {
  root.render(
    <React.StrictMode>
      <StatsigProvider client={statsigClient}>
        <App />
      </StatsigProvider>
    </React.StrictMode>,
  );
}

const sdkKey = process.env.REACT_APP_STATSIG_CLIENT_KEY;
if (sdkKey) {
  statsigClient.initializeAsync().then(renderApp).catch(renderApp);
} else {
  renderApp();
}
